import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { MenuRegistry, MenuId, registerAction2, Action2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { ExtensionsLocalizedLabel, PreferencesLocalizedLabel } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement';
import { IExtensionGalleryService, IExtensionManagementService } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement.service';
import { extensionsConfigurationNodeBase } from 'vscode/vscode/vs/workbench/services/extensionManagement/common/extensionManagement';
import { IWorkbenchExtensionManagementService, IExtensionManagementServerService, IWorkbenchExtensionEnablementService } from 'vscode/vscode/vs/workbench/services/extensionManagement/common/extensionManagement.service';
import { IExtensionIgnoredRecommendationsService } from 'vscode/vscode/vs/workbench/services/extensionRecommendations/common/extensionRecommendations.service';
import { Extensions as Extensions$4 } from 'vscode/vscode/vs/workbench/common/contributions';
import { VIEWLET_ID, CONTEXT_HAS_GALLERY, AutoUpdateConfigurationKey, HasOutdatedExtensionsContext, OUTDATED_EXTENSIONS_VIEW_ID, SELECT_INSTALL_VSIX_EXTENSION_COMMAND_ID, INSTALL_EXTENSION_FROM_VSIX_COMMAND_ID, extensionsSearchActionsMenu, LIST_WORKSPACE_UNSUPPORTED_EXTENSIONS_COMMAND_ID, WORKSPACE_RECOMMENDATIONS_VIEW_ID, THEME_ACTIONS_GROUP, INSTALL_ACTIONS_GROUP, UPDATE_ACTIONS_GROUP, TOGGLE_IGNORE_EXTENSION_ACTION_ID } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensions';
import { IExtensionsWorkbenchService } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensions.service';
import { SearchExtensionsAction, PromptExtensionInstallFailureAction, ConfigureWorkspaceFolderRecommendedExtensionsAction, InstallSpecificVersionOfExtensionAction, ReinstallAction, SetColorThemeAction, SetFileIconThemeAction, SetProductIconThemeAction, ToggleAutoUpdateForExtensionAction, ToggleAutoUpdatesForPublisherAction, TogglePreReleaseExtensionAction, ClearLanguageAction, ConfigureWorkspaceRecommendedExtensionsAction } from 'vscode/vscode/vs/workbench/contrib/extensions/browser/extensionsActions';
import { ExtensionsInput } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensionsInput';
import { ExtensionEditor } from './extensionEditor.js';
import { ExtensionsViewPaneContainer, DefaultViewsContext, SearchHasTextContext, StatusUpdater, MaliciousExtensionChecker, ExtensionsViewletViewsContribution } from './extensionsViewlet.js';
import { Extensions as Extensions$2 } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import { Extensions as Extensions$3 } from 'vscode/vscode/vs/platform/jsonschemas/common/jsonContributionRegistry';
import { ExtensionsConfigurationSchemaId, ExtensionsConfigurationSchema } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensionsFileTemplate';
import { CommandsRegistry } from 'vscode/vscode/vs/platform/commands/common/commands';
import { ICommandService } from 'vscode/vscode/vs/platform/commands/common/commands.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { KeymapExtensions } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensionsUtils';
import { areSameExtensions, getIdAndVersion } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagementUtil';
import { EditorPaneDescriptor } from 'vscode/vscode/vs/workbench/browser/editor';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { ExtensionActivationProgress } from './extensionsActivationProgress.js';
import { onUnexpectedError } from 'vscode/vscode/vs/base/common/errors';
import { ExtensionDependencyChecker } from './extensionsDependencyChecker.js';
import { CancellationToken } from 'vscode/vscode/vs/base/common/cancellation';
import { Extensions as Extensions$1 } from 'vscode/vscode/vs/workbench/common/views';
import { IViewsService } from 'vscode/vscode/vs/workbench/services/views/common/viewsService.service';
import { IClipboardService } from 'vscode/vscode/vs/platform/clipboard/common/clipboardService.service';
import { IPreferencesService } from 'vscode/vscode/vs/workbench/services/preferences/common/preferences.service';
import { RawContextKey, ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { IContextKeyService } from 'vscode/vscode/vs/platform/contextkey/common/contextkey.service';
import { Extensions } from 'vscode/vscode/vs/platform/quickinput/common/quickAccess';
import { ManageExtensionsQuickAccessProvider, InstallExtensionQuickAccessProvider } from './extensionsQuickAccess.js';
import './extensionRecommendationsService.js';
import { CONTEXT_SYNC_ENABLEMENT } from 'vscode/vscode/vs/workbench/services/userDataSync/common/userDataSync';
import { CopyAction, CutAction, PasteAction } from 'vscode/vscode/vs/editor/contrib/clipboard/browser/clipboard';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';
import './extensionsWorkbenchService.js';
import { Categories } from 'vscode/vscode/vs/platform/action/common/actionCommonCategories';
import './extensionRecommendationNotificationService.js';
import { toExtensionDescription } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions';
import { IExtensionService } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions.service';
import 'vscode/vscode/vs/platform/notification/common/notification';
import { INotificationService } from 'vscode/vscode/vs/platform/notification/common/notification.service';
import { IHostService } from 'vscode/vscode/vs/workbench/services/host/browser/host.service';
import { WorkbenchStateContext, ResourceContextKey } from 'vscode/vscode/vs/workbench/common/contextkeys';
import { IWorkspaceExtensionsConfigService } from 'vscode/vscode/vs/workbench/services/extensionRecommendations/common/workspaceExtensionsConfig.service';
import { Schemas } from 'vscode/vscode/vs/base/common/network';
import { ShowRuntimeExtensionsAction } from './abstractRuntimeExtensionsEditor.js';
import { ExtensionEnablementWorkspaceTrustTransitionParticipant } from './extensionEnablementWorkspaceTrustTransitionParticipant.js';
import { extensionsViewIcon, installWorkspaceRecommendedIcon, filterIcon, clearSearchResultsIcon, refreshIcon, configureRecommendedIcon } from 'vscode/vscode/vs/workbench/contrib/extensions/browser/extensionsIcons';
import { EXTENSION_CATEGORIES } from 'vscode/vscode/vs/platform/extensions/common/extensions';
import { isDisposable, Disposable, DisposableStore } from 'vscode/vscode/vs/base/common/lifecycle';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IFileDialogService, IDialogService } from 'vscode/vscode/vs/platform/dialogs/common/dialogs.service';
import { mnemonicButtonLabel } from 'vscode/vscode/vs/base/common/labels';
import 'vscode/vscode/vs/base/common/arrays';
import { Promises } from 'vscode/vscode/vs/base/common/async';
import { EditorExtensions } from 'vscode/vscode/vs/workbench/common/editor';
import { WORKSPACE_TRUST_EXTENSION_SUPPORT } from 'vscode/vscode/vs/workbench/services/workspaces/common/workspaceTrust';
import { ExtensionsCompletionItemsProvider } from './extensionsCompletionItemsProvider.js';
import { IQuickInputService } from 'vscode/vscode/vs/platform/quickinput/common/quickInput.service';
import { Event } from 'vscode/vscode/vs/base/common/event';
import { IPaneCompositePartService } from 'vscode/vscode/vs/workbench/services/panecomposite/browser/panecomposite.service';
import { UnsupportedExtensionsMigrationContrib } from './unsupportedExtensionsMigrationContribution.js';
import { isWeb } from 'vscode/vscode/vs/base/common/platform';
import { ExtensionStorageService } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionStorage';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { CONTEXT_KEYBINDINGS_EDITOR } from 'vscode/vscode/vs/workbench/contrib/preferences/common/preferences';
import { DeprecatedExtensionsChecker } from './deprecatedExtensionsChecker.js';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';

const _moduleId = "vs/workbench/contrib/extensions/browser/extensions.contribution";
( (Registry.as(Extensions.Quickaccess))).registerQuickAccessProvider({
    ctor: ManageExtensionsQuickAccessProvider,
    prefix: ManageExtensionsQuickAccessProvider.PREFIX,
    placeholder: ( localizeWithPath(_moduleId, 0, "Press Enter to manage extensions.")),
    helpEntries: [{ description: ( localizeWithPath(_moduleId, 1, "Manage Extensions")) }]
});
( (Registry.as(EditorExtensions.EditorPane))).registerEditorPane(EditorPaneDescriptor.create(ExtensionEditor, ExtensionEditor.ID, ( localizeWithPath(_moduleId, 2, "Extension"))), [
    ( (new SyncDescriptor(ExtensionsInput)))
]);
( (Registry.as(Extensions$1.ViewContainersRegistry))).registerViewContainer({
    id: VIEWLET_ID,
    title: ( localize2WithPath(_moduleId, 3, "Extensions")),
    openCommandActionDescriptor: {
        id: VIEWLET_ID,
        mnemonicTitle: ( localizeWithPath(_moduleId, 4, "E&&xtensions")),
        keybindings: { primary: 2048  | 1024  | 54  },
        order: 4,
    },
    ctorDescriptor: ( (new SyncDescriptor(ExtensionsViewPaneContainer))),
    icon: extensionsViewIcon,
    order: 4,
    rejectAddedViews: true,
    alwaysUseContainerInfo: true,
}, 0 );
( (Registry.as(Extensions$2.Configuration)))
    .registerConfiguration({
    ...extensionsConfigurationNodeBase,
    properties: {
        'extensions.autoUpdate': {
            enum: [true, 'onlyEnabledExtensions', 'onlySelectedExtensions', false,],
            enumItemLabels: [
                ( localizeWithPath(_moduleId, 5, "All Extensions")),
                ( localizeWithPath(_moduleId, 6, "Only Enabled Extensions")),
                ( localizeWithPath(_moduleId, 7, "Only Selected Extensions")),
                ( localizeWithPath(_moduleId, 8, "None")),
            ],
            enumDescriptions: [
                ( localizeWithPath(
                    _moduleId,
                    9,
                    'Download and install updates automatically for all extensions except for those updates are ignored.'
                )),
                ( localizeWithPath(
                    _moduleId,
                    10,
                    'Download and install updates automatically only for enabled extensions except for those updates are ignored. Disabled extensions are not updated automatically.'
                )),
                ( localizeWithPath(
                    _moduleId,
                    11,
                    'Download and install updates automatically only for selected extensions.'
                )),
                ( localizeWithPath(_moduleId, 12, 'Extensions are not automatically updated.')),
            ],
            description: ( localizeWithPath(
                _moduleId,
                13,
                "Controls the automatic update behavior of extensions. The updates are fetched from a Microsoft online service."
            )),
            default: true,
            scope: 1 ,
            tags: ['usesOnlineServices']
        },
        'extensions.autoCheckUpdates': {
            type: 'boolean',
            description: ( localizeWithPath(
                _moduleId,
                14,
                "When enabled, automatically checks extensions for updates. If an extension has an update, it is marked as outdated in the Extensions view. The updates are fetched from a Microsoft online service."
            )),
            default: true,
            scope: 1 ,
            tags: ['usesOnlineServices']
        },
        'extensions.ignoreRecommendations': {
            type: 'boolean',
            description: ( localizeWithPath(
                _moduleId,
                15,
                "When enabled, the notifications for extension recommendations will not be shown."
            )),
            default: false
        },
        'extensions.showRecommendationsOnlyOnDemand': {
            type: 'boolean',
            deprecationMessage: ( localizeWithPath(
                _moduleId,
                16,
                "This setting is deprecated. Use extensions.ignoreRecommendations setting to control recommendation notifications. Use Extensions view's visibility actions to hide Recommended view by default."
            )),
            default: false,
            tags: ['usesOnlineServices']
        },
        'extensions.closeExtensionDetailsOnViewChange': {
            type: 'boolean',
            description: ( localizeWithPath(
                _moduleId,
                17,
                "When enabled, editors with extension details will be automatically closed upon navigating away from the Extensions View."
            )),
            default: false
        },
        'extensions.confirmedUriHandlerExtensionIds': {
            type: 'array',
            items: {
                type: 'string'
            },
            description: ( localizeWithPath(
                _moduleId,
                18,
                "When an extension is listed here, a confirmation prompt will not be shown when that extension handles a URI."
            )),
            default: [],
            scope: 1
        },
        'extensions.webWorker': {
            type: ['boolean', 'string'],
            enum: [true, false, 'auto'],
            enumDescriptions: [
                ( localizeWithPath(_moduleId, 19, "The Web Worker Extension Host will always be launched.")),
                ( localizeWithPath(_moduleId, 20, "The Web Worker Extension Host will never be launched.")),
                ( localizeWithPath(
                    _moduleId,
                    21,
                    "The Web Worker Extension Host will be launched when a web extension needs it."
                )),
            ],
            description: ( localizeWithPath(_moduleId, 22, "Enable web worker extension host.")),
            default: 'auto'
        },
        'extensions.supportVirtualWorkspaces': {
            type: 'object',
            markdownDescription: ( localizeWithPath(_moduleId, 23, "Override the virtual workspaces support of an extension.")),
            patternProperties: {
                '([a-z0-9A-Z][a-z0-9-A-Z]*)\\.([a-z0-9A-Z][a-z0-9-A-Z]*)$': {
                    type: 'boolean',
                    default: false
                }
            },
            additionalProperties: false,
            default: {},
            defaultSnippets: [{
                    'body': {
                        'pub.name': false
                    }
                }]
        },
        'extensions.experimental.affinity': {
            type: 'object',
            markdownDescription: ( localizeWithPath(
                _moduleId,
                24,
                "Configure an extension to execute in a different extension host process."
            )),
            patternProperties: {
                '([a-z0-9A-Z][a-z0-9-A-Z]*)\\.([a-z0-9A-Z][a-z0-9-A-Z]*)$': {
                    type: 'integer',
                    default: 1
                }
            },
            additionalProperties: false,
            default: {},
            defaultSnippets: [{
                    'body': {
                        'pub.name': 1
                    }
                }]
        },
        [WORKSPACE_TRUST_EXTENSION_SUPPORT]: {
            type: 'object',
            scope: 1 ,
            markdownDescription: ( localizeWithPath(
                _moduleId,
                25,
                "Override the untrusted workspace support of an extension. Extensions using `true` will always be enabled. Extensions using `limited` will always be enabled, and the extension will hide functionality that requires trust. Extensions using `false` will only be enabled only when the workspace is trusted."
            )),
            patternProperties: {
                '([a-z0-9A-Z][a-z0-9-A-Z]*)\\.([a-z0-9A-Z][a-z0-9-A-Z]*)$': {
                    type: 'object',
                    properties: {
                        'supported': {
                            type: ['boolean', 'string'],
                            enum: [true, false, 'limited'],
                            enumDescriptions: [
                                ( localizeWithPath(_moduleId, 26, "Extension will always be enabled.")),
                                ( localizeWithPath(
                                    _moduleId,
                                    27,
                                    "Extension will only be enabled only when the workspace is trusted."
                                )),
                                ( localizeWithPath(
                                    _moduleId,
                                    28,
                                    "Extension will always be enabled, and the extension will hide functionality requiring trust."
                                )),
                            ],
                            description: ( localizeWithPath(
                                _moduleId,
                                29,
                                "Defines the untrusted workspace support setting for the extension."
                            )),
                        },
                        'version': {
                            type: 'string',
                            description: ( localizeWithPath(
                                _moduleId,
                                30,
                                "Defines the version of the extension for which the override should be applied. If not specified, the override will be applied independent of the extension version."
                            )),
                        }
                    }
                }
            }
        },
        'extensions.experimental.deferredStartupFinishedActivation': {
            type: 'boolean',
            description: ( localizeWithPath(
                _moduleId,
                31,
                "When enabled, extensions which declare the `onStartupFinished` activation event will be activated after a timeout."
            )),
            default: false
        },
        'extensions.experimental.issueQuickAccess': {
            type: 'boolean',
            description: ( localizeWithPath(
                _moduleId,
                32,
                "When enabled, extensions can be searched for via Quick Access and report issues from there."
            )),
            default: true
        }
    }
});
const jsonRegistry = ( (Registry.as(Extensions$3.JSONContribution)));
jsonRegistry.registerSchema(ExtensionsConfigurationSchemaId, ExtensionsConfigurationSchema);
CommandsRegistry.registerCommand('_extensions.manage', (accessor, extensionId, tab, preserveFocus, feature) => {
    const extensionService = accessor.get(IExtensionsWorkbenchService);
    const extension = extensionService.local.find(e => areSameExtensions(e.identifier, { id: extensionId }));
    if (extension) {
        extensionService.open(extension, { tab, preserveFocus, feature });
    }
    else {
        throw ( (new Error(localizeWithPath(_moduleId, 33, "Extension '{0}' not found.", extensionId))));
    }
});
CommandsRegistry.registerCommand('extension.open', async (accessor, extensionId, tab, preserveFocus, feature) => {
    const extensionService = accessor.get(IExtensionsWorkbenchService);
    const commandService = accessor.get(ICommandService);
    const [extension] = await extensionService.getExtensions([{ id: extensionId }], CancellationToken.None);
    if (extension) {
        return extensionService.open(extension, { tab, preserveFocus, feature });
    }
    return commandService.executeCommand('_extensions.manage', extensionId, tab, preserveFocus, feature);
});
CommandsRegistry.registerCommand({
    id: 'workbench.extensions.installExtension',
    metadata: {
        description: ( localizeWithPath(_moduleId, 34, "Install the given extension")),
        args: [
            {
                name: 'extensionIdOrVSIXUri',
                description: ( localizeWithPath(_moduleId, 35, "Extension id or VSIX resource uri")),
                constraint: (value) => typeof value === 'string' || value instanceof URI,
            },
            {
                name: 'options',
                description: '(optional) Options for installing the extension. Object with the following properties: ' +
                    '`installOnlyNewlyAddedFromExtensionPackVSIX`: When enabled, VS Code installs only newly added extensions from the extension pack VSIX. This option is considered only when installing VSIX. ',
                isOptional: true,
                schema: {
                    'type': 'object',
                    'properties': {
                        'installOnlyNewlyAddedFromExtensionPackVSIX': {
                            'type': 'boolean',
                            'description': ( localizeWithPath(
                                _moduleId,
                                36,
                                "When enabled, VS Code installs only newly added extensions from the extension pack VSIX. This option is considered only while installing a VSIX."
                            )),
                            default: false
                        },
                        'installPreReleaseVersion': {
                            'type': 'boolean',
                            'description': ( localizeWithPath(
                                _moduleId,
                                37,
                                "When enabled, VS Code installs the pre-release version of the extension if available."
                            )),
                            default: false
                        },
                        'donotSync': {
                            'type': 'boolean',
                            'description': ( localizeWithPath(
                                _moduleId,
                                38,
                                "When enabled, VS Code do not sync this extension when Settings Sync is on."
                            )),
                            default: false
                        },
                        'justification': {
                            'type': ['string', 'object'],
                            'description': ( localizeWithPath(
                                _moduleId,
                                39,
                                "Justification for installing the extension. This is a string or an object that can be used to pass any information to the installation handlers. i.e. `{reason: 'This extension wants to open a URI', action: 'Open URI'}` will show a message box with the reason and action upon install."
                            )),
                        },
                        'enable': {
                            'type': 'boolean',
                            'description': ( localizeWithPath(
                                _moduleId,
                                40,
                                "When enabled, the extension will be enabled if it is installed but disabled. If the extension is already enabled, this has no effect."
                            )),
                            default: false
                        },
                        'context': {
                            'type': 'object',
                            'description': ( localizeWithPath(
                                _moduleId,
                                41,
                                "Context for the installation. This is a JSON object that can be used to pass any information to the installation handlers. i.e. `{skipWalkthrough: true}` will skip opening the walkthrough upon install."
                            )),
                        }
                    }
                }
            }
        ]
    },
    handler: async (accessor, arg, options) => {
        const extensionsWorkbenchService = accessor.get(IExtensionsWorkbenchService);
        const extensionManagementService = accessor.get(IWorkbenchExtensionManagementService);
        const extensionGalleryService = accessor.get(IExtensionGalleryService);
        try {
            if (typeof arg === 'string') {
                const [id, version] = getIdAndVersion(arg);
                const extension = extensionsWorkbenchService.local.find(e => areSameExtensions(e.identifier, { id, uuid: version }));
                if (extension?.enablementState === 1 ) {
                    const [gallery] = await extensionGalleryService.getExtensions([{ id, preRelease: options?.installPreReleaseVersion }], CancellationToken.None);
                    if (!gallery) {
                        throw ( (new Error(localizeWithPath(_moduleId, 33, "Extension '{0}' not found.", arg))));
                    }
                    await extensionManagementService.installFromGallery(gallery, {
                        isMachineScoped: options?.donotSync ? true : undefined,
                        installPreReleaseVersion: options?.installPreReleaseVersion,
                        installGivenVersion: !!version,
                        context: options?.context
                    });
                }
                else {
                    await extensionsWorkbenchService.install(arg, {
                        version,
                        installPreReleaseVersion: options?.installPreReleaseVersion,
                        context: options?.context,
                        justification: options?.justification,
                        enable: options?.enable,
                        isMachineScoped: options?.donotSync ? true : undefined,
                    }, 15 );
                }
            }
            else {
                const vsix = URI.revive(arg);
                await extensionsWorkbenchService.install(vsix, { installOnlyNewlyAddedFromExtensionPack: options?.installOnlyNewlyAddedFromExtensionPackVSIX });
            }
        }
        catch (e) {
            onUnexpectedError(e);
            throw e;
        }
    }
});
CommandsRegistry.registerCommand({
    id: 'workbench.extensions.uninstallExtension',
    metadata: {
        description: ( localizeWithPath(_moduleId, 42, "Uninstall the given extension")),
        args: [
            {
                name: ( localizeWithPath(_moduleId, 43, "Id of the extension to uninstall")),
                schema: {
                    'type': 'string'
                }
            }
        ]
    },
    handler: async (accessor, id) => {
        if (!id) {
            throw ( (new Error(localizeWithPath(_moduleId, 44, "Extension id required."))));
        }
        const extensionManagementService = accessor.get(IExtensionManagementService);
        const installed = await extensionManagementService.getInstalled();
        const [extensionToUninstall] = installed.filter(e => areSameExtensions(e.identifier, { id }));
        if (!extensionToUninstall) {
            throw ( (new Error(localizeWithPath(
                _moduleId,
                45,
                "Extension '{0}' is not installed. Make sure you use the full extension ID, including the publisher, e.g.: ms-dotnettools.csharp.",
                id
            ))));
        }
        if (extensionToUninstall.isBuiltin) {
            throw ( (new Error(localizeWithPath(
                _moduleId,
                46,
                "Extension '{0}' is a Built-in extension and cannot be installed",
                id
            ))));
        }
        try {
            await extensionManagementService.uninstall(extensionToUninstall);
        }
        catch (e) {
            onUnexpectedError(e);
            throw e;
        }
    }
});
CommandsRegistry.registerCommand({
    id: 'workbench.extensions.search',
    metadata: {
        description: ( localizeWithPath(_moduleId, 47, "Search for a specific extension")),
        args: [
            {
                name: ( localizeWithPath(_moduleId, 48, "Query to use in search")),
                schema: { 'type': 'string' }
            }
        ]
    },
    handler: async (accessor, query = '') => {
        const paneCompositeService = accessor.get(IPaneCompositePartService);
        const viewlet = await paneCompositeService.openPaneComposite(VIEWLET_ID, 0 , true);
        if (!viewlet) {
            return;
        }
        viewlet.getViewPaneContainer().search(query);
        viewlet.focus();
    }
});
function overrideActionForActiveExtensionEditorWebview(command, f) {
    command?.addImplementation(105, 'extensions-editor', (accessor) => {
        const editorService = accessor.get(IEditorService);
        const editor = editorService.activeEditorPane;
        if (editor instanceof ExtensionEditor) {
            if (editor.activeWebview?.isFocused) {
                f(editor.activeWebview);
                return true;
            }
        }
        return false;
    });
}
overrideActionForActiveExtensionEditorWebview(CopyAction, webview => webview.copy());
overrideActionForActiveExtensionEditorWebview(CutAction, webview => webview.cut());
overrideActionForActiveExtensionEditorWebview(PasteAction, webview => webview.paste());
const CONTEXT_HAS_LOCAL_SERVER = ( (new RawContextKey('hasLocalServer', false)));
const CONTEXT_HAS_REMOTE_SERVER = ( (new RawContextKey('hasRemoteServer', false)));
const CONTEXT_HAS_WEB_SERVER = ( (new RawContextKey('hasWebServer', false)));
async function runAction(action) {
    try {
        await action.run();
    }
    finally {
        if (isDisposable(action)) {
            action.dispose();
        }
    }
}
let ExtensionsContributions = class ExtensionsContributions extends Disposable {
    constructor(extensionManagementServerService, extensionGalleryService, contextKeyService, paneCompositeService, extensionsWorkbenchService, extensionEnablementService, instantiationService, dialogService, commandService) {
        super();
        this.extensionManagementServerService = extensionManagementServerService;
        this.paneCompositeService = paneCompositeService;
        this.extensionsWorkbenchService = extensionsWorkbenchService;
        this.extensionEnablementService = extensionEnablementService;
        this.instantiationService = instantiationService;
        this.dialogService = dialogService;
        this.commandService = commandService;
        const hasGalleryContext = CONTEXT_HAS_GALLERY.bindTo(contextKeyService);
        if (extensionGalleryService.isEnabled()) {
            hasGalleryContext.set(true);
        }
        const hasLocalServerContext = CONTEXT_HAS_LOCAL_SERVER.bindTo(contextKeyService);
        if (this.extensionManagementServerService.localExtensionManagementServer) {
            hasLocalServerContext.set(true);
        }
        const hasRemoteServerContext = CONTEXT_HAS_REMOTE_SERVER.bindTo(contextKeyService);
        if (this.extensionManagementServerService.remoteExtensionManagementServer) {
            hasRemoteServerContext.set(true);
        }
        const hasWebServerContext = CONTEXT_HAS_WEB_SERVER.bindTo(contextKeyService);
        if (this.extensionManagementServerService.webExtensionManagementServer) {
            hasWebServerContext.set(true);
        }
        this.registerGlobalActions();
        this.registerContextMenuActions();
        this.registerQuickAccessProvider();
    }
    registerQuickAccessProvider() {
        if (this.extensionManagementServerService.localExtensionManagementServer
            || this.extensionManagementServerService.remoteExtensionManagementServer
            || this.extensionManagementServerService.webExtensionManagementServer) {
            ( (Registry.as(Extensions.Quickaccess))).registerQuickAccessProvider({
                ctor: InstallExtensionQuickAccessProvider,
                prefix: InstallExtensionQuickAccessProvider.PREFIX,
                placeholder: ( localizeWithPath(_moduleId, 49, "Type the name of an extension to install or search.")),
                helpEntries: [{ description: ( localizeWithPath(_moduleId, 50, "Install or Search Extensions")) }]
            });
        }
    }
    registerGlobalActions() {
        this._register(MenuRegistry.appendMenuItem(MenuId.MenubarPreferencesMenu, {
            command: {
                id: VIEWLET_ID,
                title: ( localizeWithPath(_moduleId, 51, "&&Extensions"))
            },
            group: '2_configuration',
            order: 3
        }));
        this._register(MenuRegistry.appendMenuItem(MenuId.GlobalActivity, {
            command: {
                id: VIEWLET_ID,
                title: ( localizeWithPath(_moduleId, 52, "Extensions"))
            },
            group: '2_configuration',
            order: 3
        }));
        this.registerExtensionAction({
            id: 'workbench.extensions.action.focusExtensionsView',
            title: ( localize2WithPath(_moduleId, 53, 'Focus on Extensions View')),
            category: ExtensionsLocalizedLabel,
            f1: true,
            run: async (accessor) => {
                await accessor.get(IPaneCompositePartService).openPaneComposite(VIEWLET_ID, 0 , true);
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.installExtensions',
            title: ( localize2WithPath(_moduleId, 54, 'Install Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(CONTEXT_HAS_GALLERY,  (ContextKeyExpr.or(
                    CONTEXT_HAS_LOCAL_SERVER,
                    CONTEXT_HAS_REMOTE_SERVER,
                    CONTEXT_HAS_WEB_SERVER
                )))))
            },
            run: async (accessor) => {
                accessor.get(IViewsService).openViewContainer(VIEWLET_ID, true);
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.showRecommendedKeymapExtensions',
            title: ( localize2WithPath(_moduleId, 55, 'Keymaps')),
            category: PreferencesLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: CONTEXT_HAS_GALLERY
                }, {
                    id: MenuId.EditorTitle,
                    when: ( (ContextKeyExpr.and(CONTEXT_KEYBINDINGS_EDITOR, CONTEXT_HAS_GALLERY))),
                    group: '2_keyboard_discover_actions'
                }],
            menuTitles: {
                [MenuId.EditorTitle.id]: ( localizeWithPath(_moduleId, 56, "Migrate Keyboard Shortcuts from..."))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@recommended:keymaps '))
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.showLanguageExtensions',
            title: ( localize2WithPath(_moduleId, 57, 'Language Extensions')),
            category: PreferencesLocalizedLabel,
            menu: {
                id: MenuId.CommandPalette,
                when: CONTEXT_HAS_GALLERY
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@recommended:languages '))
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.checkForUpdates',
            title: ( localize2WithPath(_moduleId, 58, 'Check for Extension Updates')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.and(CONTEXT_HAS_GALLERY,  (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    )))))
                }, {
                    id: MenuId.ViewContainerTitle,
                    when: ( (ContextKeyExpr.and(
                         (ContextKeyExpr.equals('viewContainer', VIEWLET_ID)),
                        CONTEXT_HAS_GALLERY
                    ))),
                    group: '1_updates',
                    order: 1
                }],
            run: async () => {
                await this.extensionsWorkbenchService.checkForUpdates();
                const outdated = this.extensionsWorkbenchService.outdated;
                if (outdated.length) {
                    return runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@outdated '));
                }
                else {
                    return this.dialogService.info(( localizeWithPath(_moduleId, 59, "All extensions are up to date.")));
                }
            }
        });
        const autoUpdateExtensionsSubMenu = ( (new MenuId('autoUpdateExtensionsSubMenu')));
        MenuRegistry.appendMenuItem(MenuId.ViewContainerTitle, {
            submenu: autoUpdateExtensionsSubMenu,
            title: ( localizeWithPath(_moduleId, 60, "Auto Update Extensions")),
            when: ( (ContextKeyExpr.and(
                 (ContextKeyExpr.equals('viewContainer', VIEWLET_ID)),
                CONTEXT_HAS_GALLERY
            ))),
            group: '1_updates',
            order: 5,
        });
        this.registerExtensionAction({
            id: 'configureExtensionsAutoUpdate.all',
            title: ( localizeWithPath(_moduleId, 61, "All Extensions")),
            toggled: ( (ContextKeyExpr.and(
                 (ContextKeyExpr.has(`config.${AutoUpdateConfigurationKey}`)),
                 (ContextKeyExpr.notEquals(`config.${AutoUpdateConfigurationKey}`, 'onlyEnabledExtensions')),
                 (ContextKeyExpr.notEquals(`config.${AutoUpdateConfigurationKey}`, 'onlySelectedExtensions'))
            ))),
            menu: [{
                    id: autoUpdateExtensionsSubMenu,
                    order: 1,
                }],
            run: (accessor) => accessor.get(IConfigurationService).updateValue(AutoUpdateConfigurationKey, true)
        });
        this.registerExtensionAction({
            id: 'configureExtensionsAutoUpdate.enabled',
            title: ( localizeWithPath(_moduleId, 62, "Enabled Extensions")),
            toggled: ( (ContextKeyExpr.equals(`config.${AutoUpdateConfigurationKey}`, 'onlyEnabledExtensions'))),
            menu: [{
                    id: autoUpdateExtensionsSubMenu,
                    order: 2,
                }],
            run: (accessor) => accessor.get(IConfigurationService).updateValue(AutoUpdateConfigurationKey, 'onlyEnabledExtensions')
        });
        this.registerExtensionAction({
            id: 'configureExtensionsAutoUpdate.selected',
            title: ( localizeWithPath(_moduleId, 63, "Selected Extensions")),
            toggled: ( (ContextKeyExpr.equals(`config.${AutoUpdateConfigurationKey}`, 'onlySelectedExtensions'))),
            menu: [{
                    id: autoUpdateExtensionsSubMenu,
                    order: 2,
                }],
            run: (accessor) => accessor.get(IConfigurationService).updateValue(AutoUpdateConfigurationKey, 'onlySelectedExtensions')
        });
        this.registerExtensionAction({
            id: 'configureExtensionsAutoUpdate.none',
            title: ( localizeWithPath(_moduleId, 64, "None")),
            toggled: ( (ContextKeyExpr.equals(`config.${AutoUpdateConfigurationKey}`, false))),
            menu: [{
                    id: autoUpdateExtensionsSubMenu,
                    order: 3,
                }],
            run: (accessor) => accessor.get(IConfigurationService).updateValue(AutoUpdateConfigurationKey, false)
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.updateAllExtensions',
            title: ( localize2WithPath(_moduleId, 65, 'Update All Extensions')),
            category: ExtensionsLocalizedLabel,
            precondition: HasOutdatedExtensionsContext,
            menu: [
                {
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.and(CONTEXT_HAS_GALLERY,  (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    )))))
                }, {
                    id: MenuId.ViewContainerTitle,
                    when: ( (ContextKeyExpr.and(
                         (ContextKeyExpr.equals('viewContainer', VIEWLET_ID)),
                         (ContextKeyExpr.or(
                             (( (ContextKeyExpr.has(`config.${AutoUpdateConfigurationKey}`))).negate()),
                             (ContextKeyExpr.equals(`config.${AutoUpdateConfigurationKey}`, 'onlyEnabledExtensions'))
                        ))
                    ))),
                    group: '1_updates',
                    order: 2
                }, {
                    id: MenuId.ViewTitle,
                    when: ( (ContextKeyExpr.equals('view', OUTDATED_EXTENSIONS_VIEW_ID))),
                    group: 'navigation',
                    order: 1
                }
            ],
            icon: installWorkspaceRecommendedIcon,
            run: async () => {
                const outdated = this.extensionsWorkbenchService.outdated;
                const results = await this.extensionsWorkbenchService.updateAll();
                results.forEach((result) => {
                    if (result.error) {
                        const extension = outdated.find((extension) => areSameExtensions(extension.identifier, result.identifier));
                        if (extension) {
                            runAction(this.instantiationService.createInstance(PromptExtensionInstallFailureAction, extension, extension.latestVersion, 3 , result.error));
                        }
                    }
                });
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.disableAutoUpdate',
            title: ( localize2WithPath(_moduleId, 66, 'Disable Auto Update for All Extensions')),
            category: ExtensionsLocalizedLabel,
            f1: true,
            precondition: CONTEXT_HAS_GALLERY,
            run: (accessor) => accessor.get(IConfigurationService).updateValue(AutoUpdateConfigurationKey, false)
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.enableAutoUpdate',
            title: ( localize2WithPath(_moduleId, 67, 'Enable Auto Update for All Extensions')),
            category: ExtensionsLocalizedLabel,
            f1: true,
            precondition: CONTEXT_HAS_GALLERY,
            run: (accessor) => accessor.get(IConfigurationService).updateValue(AutoUpdateConfigurationKey, true)
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.enableAll',
            title: ( localize2WithPath(_moduleId, 68, 'Enable All Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    )))
                }, {
                    id: MenuId.ViewContainerTitle,
                    when: ( (ContextKeyExpr.equals('viewContainer', VIEWLET_ID))),
                    group: '2_enablement',
                    order: 1
                }],
            run: async () => {
                const extensionsToEnable = this.extensionsWorkbenchService.local.filter(e => !!e.local && this.extensionEnablementService.canChangeEnablement(e.local) && !this.extensionEnablementService.isEnabled(e.local));
                if (extensionsToEnable.length) {
                    await this.extensionsWorkbenchService.setEnablement(extensionsToEnable, 8 );
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.enableAllWorkspace',
            title: ( localize2WithPath(_moduleId, 69, 'Enable All Extensions for this Workspace')),
            category: ExtensionsLocalizedLabel,
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(
                     (WorkbenchStateContext.notEqualsTo('empty')),
                     (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    ))
                )))
            },
            run: async () => {
                const extensionsToEnable = this.extensionsWorkbenchService.local.filter(e => !!e.local && this.extensionEnablementService.canChangeEnablement(e.local) && !this.extensionEnablementService.isEnabled(e.local));
                if (extensionsToEnable.length) {
                    await this.extensionsWorkbenchService.setEnablement(extensionsToEnable, 9 );
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.disableAll',
            title: ( localize2WithPath(_moduleId, 70, 'Disable All Installed Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    )))
                }, {
                    id: MenuId.ViewContainerTitle,
                    when: ( (ContextKeyExpr.equals('viewContainer', VIEWLET_ID))),
                    group: '2_enablement',
                    order: 2
                }],
            run: async () => {
                const extensionsToDisable = this.extensionsWorkbenchService.local.filter(e => !e.isBuiltin && !!e.local && this.extensionEnablementService.isEnabled(e.local) && this.extensionEnablementService.canChangeEnablement(e.local));
                if (extensionsToDisable.length) {
                    await this.extensionsWorkbenchService.setEnablement(extensionsToDisable, 6 );
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.disableAllWorkspace',
            title: ( localize2WithPath(_moduleId, 71, 'Disable All Installed Extensions for this Workspace')),
            category: ExtensionsLocalizedLabel,
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(
                     (WorkbenchStateContext.notEqualsTo('empty')),
                     (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    ))
                )))
            },
            run: async () => {
                const extensionsToDisable = this.extensionsWorkbenchService.local.filter(e => !e.isBuiltin && !!e.local && this.extensionEnablementService.isEnabled(e.local) && this.extensionEnablementService.canChangeEnablement(e.local));
                if (extensionsToDisable.length) {
                    await this.extensionsWorkbenchService.setEnablement(extensionsToDisable, 7 );
                }
            }
        });
        this.registerExtensionAction({
            id: SELECT_INSTALL_VSIX_EXTENSION_COMMAND_ID,
            title: ( localize2WithPath(_moduleId, 72, 'Install from VSIX...')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.or(CONTEXT_HAS_LOCAL_SERVER, CONTEXT_HAS_REMOTE_SERVER)))
                }, {
                    id: MenuId.ViewContainerTitle,
                    when: ( (ContextKeyExpr.and(
                         (ContextKeyExpr.equals('viewContainer', VIEWLET_ID)),
                         (ContextKeyExpr.or(CONTEXT_HAS_LOCAL_SERVER, CONTEXT_HAS_REMOTE_SERVER))
                    ))),
                    group: '3_install',
                    order: 1
                }],
            run: async (accessor) => {
                const fileDialogService = accessor.get(IFileDialogService);
                const commandService = accessor.get(ICommandService);
                const vsixPaths = await fileDialogService.showOpenDialog({
                    title: ( localizeWithPath(_moduleId, 73, "Install from VSIX")),
                    filters: [{ name: 'VSIX Extensions', extensions: ['vsix'] }],
                    canSelectFiles: true,
                    canSelectMany: true,
                    openLabel: mnemonicButtonLabel(( localizeWithPath(_moduleId, 74, "&&Install")))
                });
                if (vsixPaths) {
                    await commandService.executeCommand(INSTALL_EXTENSION_FROM_VSIX_COMMAND_ID, vsixPaths);
                }
            }
        });
        this.registerExtensionAction({
            id: INSTALL_EXTENSION_FROM_VSIX_COMMAND_ID,
            title: ( localizeWithPath(_moduleId, 75, "Install Extension VSIX")),
            menu: [{
                    id: MenuId.ExplorerContext,
                    group: 'extensions',
                    when: ( (ContextKeyExpr.and(
                         (ResourceContextKey.Extension.isEqualTo('.vsix')),
                         (ContextKeyExpr.or(CONTEXT_HAS_LOCAL_SERVER, CONTEXT_HAS_REMOTE_SERVER))
                    ))),
                }],
            run: async (accessor, resources) => {
                const extensionService = accessor.get(IExtensionService);
                const extensionsWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const hostService = accessor.get(IHostService);
                const notificationService = accessor.get(INotificationService);
                const extensions = Array.isArray(resources) ? resources : [resources];
                await Promises.settled(( (extensions.map(async (vsix) => await extensionsWorkbenchService.install(vsix)))))
                    .then(async (extensions) => {
                    for (const extension of extensions) {
                        const requireReload = !(extension.local && extensionService.canAddExtension(toExtensionDescription(extension.local)));
                        const message = requireReload ? ( localizeWithPath(
                            _moduleId,
                            76,
                            "Completed installing {0} extension from VSIX. Please reload Visual Studio Code to enable it.",
                            extension.displayName || extension.name
                        ))
                            : ( localizeWithPath(
                            _moduleId,
                            77,
                            "Completed installing {0} extension from VSIX.",
                            extension.displayName || extension.name
                        ));
                        const actions = requireReload ? [{
                                label: ( localizeWithPath(_moduleId, 78, "Reload Now")),
                                run: () => hostService.reload()
                            }] : [];
                        notificationService.prompt(Severity$1.Info, message, actions);
                    }
                });
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.installExtensionFromLocation',
            title: ( localize2WithPath(_moduleId, 79, 'Install Extension from Location...')),
            category: Categories.Developer,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.or(CONTEXT_HAS_WEB_SERVER, CONTEXT_HAS_LOCAL_SERVER)))
                }],
            run: async (accessor) => {
                const extensionManagementService = accessor.get(IWorkbenchExtensionManagementService);
                if (isWeb) {
                    return (
                         (new Promise((c, e) => {
                            const quickInputService = accessor.get(IQuickInputService);
                            const disposables = ( (new DisposableStore()));
                            const quickPick = disposables.add(quickInputService.createQuickPick());
                            quickPick.title = ( localizeWithPath(_moduleId, 80, "Install Extension from Location"));
                            quickPick.customButton = true;
                            quickPick.customLabel = ( localizeWithPath(_moduleId, 81, "Install"));
                            quickPick.placeholder = ( localizeWithPath(_moduleId, 82, "Location of the web extension"));
                            quickPick.ignoreFocusOut = true;
                            disposables.add(Event.any(quickPick.onDidAccept, quickPick.onDidCustom)(async () => {
                                quickPick.hide();
                                if (quickPick.value) {
                                    try {
                                        await extensionManagementService.installFromLocation(( (URI.parse(quickPick.value))));
                                    }
                                    catch (error) {
                                        e(error);
                                        return;
                                    }
                                }
                                c();
                            }));
                            disposables.add(quickPick.onDidHide(() => disposables.dispose()));
                            quickPick.show();
                        }))
                    );
                }
                else {
                    const fileDialogService = accessor.get(IFileDialogService);
                    const extensionLocation = await fileDialogService.showOpenDialog({
                        canSelectFolders: true,
                        canSelectFiles: false,
                        canSelectMany: false,
                        title: ( localizeWithPath(_moduleId, 80, "Install Extension from Location")),
                    });
                    if (extensionLocation?.[0]) {
                        await extensionManagementService.installFromLocation(extensionLocation[0]);
                    }
                }
            }
        });
        const extensionsFilterSubMenu = ( (new MenuId('extensionsFilterSubMenu')));
        MenuRegistry.appendMenuItem(extensionsSearchActionsMenu, {
            submenu: extensionsFilterSubMenu,
            title: ( localizeWithPath(_moduleId, 83, "Filter Extensions...")),
            group: 'navigation',
            order: 2,
            icon: filterIcon,
        });
        const showFeaturedExtensionsId = 'extensions.filter.featured';
        this.registerExtensionAction({
            id: showFeaturedExtensionsId,
            title: ( localize2WithPath(_moduleId, 84, 'Show Featured Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: CONTEXT_HAS_GALLERY
                }, {
                    id: extensionsFilterSubMenu,
                    when: CONTEXT_HAS_GALLERY,
                    group: '1_predefined',
                    order: 1,
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 85, "Featured"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@featured '))
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.showPopularExtensions',
            title: ( localize2WithPath(_moduleId, 86, 'Show Popular Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: CONTEXT_HAS_GALLERY
                }, {
                    id: extensionsFilterSubMenu,
                    when: CONTEXT_HAS_GALLERY,
                    group: '1_predefined',
                    order: 2,
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 87, "Most Popular"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@popular '))
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.showRecommendedExtensions',
            title: ( localize2WithPath(_moduleId, 88, 'Show Recommended Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: CONTEXT_HAS_GALLERY
                }, {
                    id: extensionsFilterSubMenu,
                    when: CONTEXT_HAS_GALLERY,
                    group: '1_predefined',
                    order: 2,
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 89, "Recommended"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@recommended '))
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.recentlyPublishedExtensions',
            title: ( localize2WithPath(_moduleId, 90, 'Show Recently Published Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: CONTEXT_HAS_GALLERY
                }, {
                    id: extensionsFilterSubMenu,
                    when: CONTEXT_HAS_GALLERY,
                    group: '1_predefined',
                    order: 2,
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 91, "Recently Published"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@recentlyPublished '))
        });
        const extensionsCategoryFilterSubMenu = ( (new MenuId('extensionsCategoryFilterSubMenu')));
        MenuRegistry.appendMenuItem(extensionsFilterSubMenu, {
            submenu: extensionsCategoryFilterSubMenu,
            title: ( localizeWithPath(_moduleId, 92, "Category")),
            when: CONTEXT_HAS_GALLERY,
            group: '2_categories',
            order: 1,
        });
        EXTENSION_CATEGORIES.forEach((category, index) => {
            this.registerExtensionAction({
                id: `extensions.actions.searchByCategory.${category}`,
                title: category,
                menu: [{
                        id: extensionsCategoryFilterSubMenu,
                        when: CONTEXT_HAS_GALLERY,
                        order: index,
                    }],
                run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, `@category:"${category.toLowerCase()}"`))
            });
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.listBuiltInExtensions',
            title: ( localize2WithPath(_moduleId, 93, 'Show Built-in Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    )))
                }, {
                    id: extensionsFilterSubMenu,
                    group: '3_installed',
                    order: 2,
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 94, "Built-in"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@builtin '))
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.extensionUpdates',
            title: ( localize2WithPath(_moduleId, 95, 'Show Extension Updates')),
            category: ExtensionsLocalizedLabel,
            precondition: CONTEXT_HAS_GALLERY,
            f1: true,
            menu: [{
                    id: extensionsFilterSubMenu,
                    group: '3_installed',
                    when: CONTEXT_HAS_GALLERY,
                    order: 1,
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 96, "Updates"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@updates'))
        });
        this.registerExtensionAction({
            id: LIST_WORKSPACE_UNSUPPORTED_EXTENSIONS_COMMAND_ID,
            title: ( localize2WithPath(_moduleId, 97, 'Show Extensions Unsupported By Workspace')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.or(CONTEXT_HAS_LOCAL_SERVER, CONTEXT_HAS_REMOTE_SERVER))),
                }, {
                    id: extensionsFilterSubMenu,
                    group: '3_installed',
                    order: 5,
                    when: ( (ContextKeyExpr.or(CONTEXT_HAS_LOCAL_SERVER, CONTEXT_HAS_REMOTE_SERVER))),
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 98, "Workspace Unsupported"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@workspaceUnsupported'))
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.showEnabledExtensions',
            title: ( localize2WithPath(_moduleId, 99, 'Show Enabled Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    )))
                }, {
                    id: extensionsFilterSubMenu,
                    group: '3_installed',
                    order: 3,
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 100, "Enabled"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@enabled '))
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.showDisabledExtensions',
            title: ( localize2WithPath(_moduleId, 101, 'Show Disabled Extensions')),
            category: ExtensionsLocalizedLabel,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (ContextKeyExpr.or(
                        CONTEXT_HAS_LOCAL_SERVER,
                        CONTEXT_HAS_REMOTE_SERVER,
                        CONTEXT_HAS_WEB_SERVER
                    )))
                }, {
                    id: extensionsFilterSubMenu,
                    group: '3_installed',
                    order: 4,
                }],
            menuTitles: {
                [extensionsFilterSubMenu.id]: ( localizeWithPath(_moduleId, 102, "Disabled"))
            },
            run: () => runAction(this.instantiationService.createInstance(SearchExtensionsAction, '@disabled '))
        });
        const extensionsSortSubMenu = ( (new MenuId('extensionsSortSubMenu')));
        MenuRegistry.appendMenuItem(extensionsFilterSubMenu, {
            submenu: extensionsSortSubMenu,
            title: ( localizeWithPath(_moduleId, 103, "Sort By")),
            when: ( (ContextKeyExpr.and(
                 (ContextKeyExpr.or(CONTEXT_HAS_GALLERY, DefaultViewsContext))
            ))),
            group: '4_sort',
            order: 1,
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.clearExtensionsSearchResults',
            title: ( localize2WithPath(_moduleId, 109, 'Clear Extensions Search Results')),
            category: ExtensionsLocalizedLabel,
            icon: clearSearchResultsIcon,
            f1: true,
            precondition: SearchHasTextContext,
            menu: {
                id: extensionsSearchActionsMenu,
                group: 'navigation',
                order: 1,
            },
            run: async (accessor) => {
                const viewPaneContainer = accessor.get(IViewsService).getActiveViewPaneContainerWithId(VIEWLET_ID);
                if (viewPaneContainer) {
                    const extensionsViewPaneContainer = viewPaneContainer;
                    extensionsViewPaneContainer.search('');
                    extensionsViewPaneContainer.focus();
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.refreshExtension',
            title: ( localize2WithPath(_moduleId, 110, 'Refresh')),
            category: ExtensionsLocalizedLabel,
            icon: refreshIcon,
            f1: true,
            menu: {
                id: MenuId.ViewContainerTitle,
                when: ( (ContextKeyExpr.equals('viewContainer', VIEWLET_ID))),
                group: 'navigation',
                order: 2
            },
            run: async (accessor) => {
                const viewPaneContainer = accessor.get(IViewsService).getActiveViewPaneContainerWithId(VIEWLET_ID);
                if (viewPaneContainer) {
                    await viewPaneContainer.refresh();
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.installWorkspaceRecommendedExtensions',
            title: ( localizeWithPath(_moduleId, 111, "Install Workspace Recommended Extensions")),
            icon: installWorkspaceRecommendedIcon,
            menu: {
                id: MenuId.ViewTitle,
                when: ( (ContextKeyExpr.equals('view', WORKSPACE_RECOMMENDATIONS_VIEW_ID))),
                group: 'navigation',
                order: 1
            },
            run: async (accessor) => {
                const view = accessor.get(IViewsService).getActiveViewWithId(WORKSPACE_RECOMMENDATIONS_VIEW_ID);
                return view.installWorkspaceRecommendations();
            }
        });
        this.registerExtensionAction({
            id: ConfigureWorkspaceFolderRecommendedExtensionsAction.ID,
            title: ConfigureWorkspaceFolderRecommendedExtensionsAction.LABEL,
            icon: configureRecommendedIcon,
            menu: [{
                    id: MenuId.CommandPalette,
                    when: ( (WorkbenchStateContext.notEqualsTo('empty'))),
                }, {
                    id: MenuId.ViewTitle,
                    when: ( (ContextKeyExpr.equals('view', WORKSPACE_RECOMMENDATIONS_VIEW_ID))),
                    group: 'navigation',
                    order: 2
                }],
            run: () => runAction(this.instantiationService.createInstance(ConfigureWorkspaceFolderRecommendedExtensionsAction, ConfigureWorkspaceFolderRecommendedExtensionsAction.ID, ConfigureWorkspaceFolderRecommendedExtensionsAction.LABEL))
        });
        this.registerExtensionAction({
            id: InstallSpecificVersionOfExtensionAction.ID,
            title: { value: InstallSpecificVersionOfExtensionAction.LABEL, original: 'Install Specific Version of Extension...' },
            category: ExtensionsLocalizedLabel,
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(CONTEXT_HAS_GALLERY,  (ContextKeyExpr.or(
                    CONTEXT_HAS_LOCAL_SERVER,
                    CONTEXT_HAS_REMOTE_SERVER,
                    CONTEXT_HAS_WEB_SERVER
                )))))
            },
            run: () => runAction(this.instantiationService.createInstance(InstallSpecificVersionOfExtensionAction, InstallSpecificVersionOfExtensionAction.ID, InstallSpecificVersionOfExtensionAction.LABEL))
        });
        this.registerExtensionAction({
            id: ReinstallAction.ID,
            title: { value: ReinstallAction.LABEL, original: 'Reinstall Extension...' },
            category: Categories.Developer,
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(
                    CONTEXT_HAS_GALLERY,
                     (ContextKeyExpr.or(CONTEXT_HAS_LOCAL_SERVER, CONTEXT_HAS_REMOTE_SERVER))
                )))
            },
            run: () => runAction(this.instantiationService.createInstance(ReinstallAction, ReinstallAction.ID, ReinstallAction.LABEL))
        });
    }
    registerContextMenuActions() {
        this.registerExtensionAction({
            id: SetColorThemeAction.ID,
            title: SetColorThemeAction.TITLE,
            menu: {
                id: MenuId.ExtensionContext,
                group: THEME_ACTIONS_GROUP,
                order: 0,
                when: ( (ContextKeyExpr.and(
                    ContextKeyExpr.not('inExtensionEditor'),
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                     (ContextKeyExpr.has('extensionHasColorThemes'))
                )))
            },
            run: async (accessor, extensionId) => {
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const instantiationService = accessor.get(IInstantiationService);
                const extension = extensionWorkbenchService.local.find(e => areSameExtensions(e.identifier, { id: extensionId }));
                if (extension) {
                    const action = instantiationService.createInstance(SetColorThemeAction);
                    action.extension = extension;
                    return action.run();
                }
            }
        });
        this.registerExtensionAction({
            id: SetFileIconThemeAction.ID,
            title: SetFileIconThemeAction.TITLE,
            menu: {
                id: MenuId.ExtensionContext,
                group: THEME_ACTIONS_GROUP,
                order: 0,
                when: ( (ContextKeyExpr.and(
                    ContextKeyExpr.not('inExtensionEditor'),
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                     (ContextKeyExpr.has('extensionHasFileIconThemes'))
                )))
            },
            run: async (accessor, extensionId) => {
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const instantiationService = accessor.get(IInstantiationService);
                const extension = extensionWorkbenchService.local.find(e => areSameExtensions(e.identifier, { id: extensionId }));
                if (extension) {
                    const action = instantiationService.createInstance(SetFileIconThemeAction);
                    action.extension = extension;
                    return action.run();
                }
            }
        });
        this.registerExtensionAction({
            id: SetProductIconThemeAction.ID,
            title: SetProductIconThemeAction.TITLE,
            menu: {
                id: MenuId.ExtensionContext,
                group: THEME_ACTIONS_GROUP,
                order: 0,
                when: ( (ContextKeyExpr.and(
                    ContextKeyExpr.not('inExtensionEditor'),
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                     (ContextKeyExpr.has('extensionHasProductIconThemes'))
                )))
            },
            run: async (accessor, extensionId) => {
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const instantiationService = accessor.get(IInstantiationService);
                const extension = extensionWorkbenchService.local.find(e => areSameExtensions(e.identifier, { id: extensionId }));
                if (extension) {
                    const action = instantiationService.createInstance(SetProductIconThemeAction);
                    action.extension = extension;
                    return action.run();
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.showPreReleaseVersion',
            title: ( localize2WithPath(_moduleId, 112, 'Show Pre-Release Version')),
            menu: {
                id: MenuId.ExtensionContext,
                group: INSTALL_ACTIONS_GROUP,
                order: 0,
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.has('inExtensionEditor')),
                     (ContextKeyExpr.has('galleryExtensionHasPreReleaseVersion')),
                    ContextKeyExpr.not('showPreReleaseVersion'),
                    ContextKeyExpr.not('isBuiltinExtension')
                )))
            },
            run: async (accessor, extensionId) => {
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const extension = (await extensionWorkbenchService.getExtensions([{ id: extensionId }], CancellationToken.None))[0];
                extensionWorkbenchService.open(extension, { showPreReleaseVersion: true });
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.showReleasedVersion',
            title: ( localize2WithPath(_moduleId, 113, 'Show Release Version')),
            menu: {
                id: MenuId.ExtensionContext,
                group: INSTALL_ACTIONS_GROUP,
                order: 1,
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.has('inExtensionEditor')),
                     (ContextKeyExpr.has('galleryExtensionHasPreReleaseVersion')),
                     (ContextKeyExpr.has('extensionHasReleaseVersion')),
                     (ContextKeyExpr.has('showPreReleaseVersion')),
                    ContextKeyExpr.not('isBuiltinExtension')
                )))
            },
            run: async (accessor, extensionId) => {
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const extension = (await extensionWorkbenchService.getExtensions([{ id: extensionId }], CancellationToken.None))[0];
                extensionWorkbenchService.open(extension, { showPreReleaseVersion: false });
            }
        });
        this.registerExtensionAction({
            id: ToggleAutoUpdateForExtensionAction.ID,
            title: ToggleAutoUpdateForExtensionAction.LABEL,
            category: ExtensionsLocalizedLabel,
            menu: {
                id: MenuId.ExtensionContext,
                group: UPDATE_ACTIONS_GROUP,
                order: 1,
                when: ( (ContextKeyExpr.and(
                    ContextKeyExpr.not('inExtensionEditor'),
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                    ContextKeyExpr.not('isBuiltinExtension'),
                     (ContextKeyExpr.or(
                         (ContextKeyExpr.equals(`config.${AutoUpdateConfigurationKey}`, 'onlySelectedExtensions')),
                         (ContextKeyExpr.equals(`config.${AutoUpdateConfigurationKey}`, false))
                    ))
                )))
            },
            run: async (accessor, id) => {
                const instantiationService = accessor.get(IInstantiationService);
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const extension = extensionWorkbenchService.local.find(e => areSameExtensions(e.identifier, { id }));
                if (extension) {
                    const action = instantiationService.createInstance(ToggleAutoUpdateForExtensionAction, false, []);
                    action.extension = extension;
                    return action.run();
                }
            }
        });
        this.registerExtensionAction({
            id: ToggleAutoUpdatesForPublisherAction.ID,
            title: { value: ToggleAutoUpdatesForPublisherAction.LABEL, original: 'Auto Update (Publisher)' },
            category: ExtensionsLocalizedLabel,
            menu: {
                id: MenuId.ExtensionContext,
                group: UPDATE_ACTIONS_GROUP,
                order: 2,
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                    ContextKeyExpr.not('isBuiltinExtension'),
                     (ContextKeyExpr.or(
                         (ContextKeyExpr.equals(`config.${AutoUpdateConfigurationKey}`, 'onlySelectedExtensions')),
                         (ContextKeyExpr.equals(`config.${AutoUpdateConfigurationKey}`, false))
                    ))
                )))
            },
            run: async (accessor, id) => {
                const instantiationService = accessor.get(IInstantiationService);
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const extension = extensionWorkbenchService.local.find(e => areSameExtensions(e.identifier, { id }));
                if (extension) {
                    const action = instantiationService.createInstance(ToggleAutoUpdatesForPublisherAction);
                    action.extension = extension;
                    return action.run();
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.switchToPreRlease',
            title: ( localizeWithPath(_moduleId, 114, "Switch to Pre-Release Version")),
            category: ExtensionsLocalizedLabel,
            menu: {
                id: MenuId.ExtensionContext,
                group: INSTALL_ACTIONS_GROUP,
                order: 2,
                when: ( (ContextKeyExpr.and(
                    CONTEXT_HAS_GALLERY,
                     (ContextKeyExpr.has('galleryExtensionHasPreReleaseVersion')),
                    ContextKeyExpr.not('installedExtensionIsOptedToPreRelease'),
                    ContextKeyExpr.not('inExtensionEditor'),
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                    ContextKeyExpr.not('isBuiltinExtension')
                )))
            },
            run: async (accessor, id) => {
                const instantiationService = accessor.get(IInstantiationService);
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const extension = extensionWorkbenchService.local.find(e => areSameExtensions(e.identifier, { id }));
                if (extension) {
                    const action = instantiationService.createInstance(TogglePreReleaseExtensionAction);
                    action.extension = extension;
                    return action.run();
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.switchToRelease',
            title: ( localizeWithPath(_moduleId, 115, "Switch to Release Version")),
            category: ExtensionsLocalizedLabel,
            menu: {
                id: MenuId.ExtensionContext,
                group: INSTALL_ACTIONS_GROUP,
                order: 2,
                when: ( (ContextKeyExpr.and(
                    CONTEXT_HAS_GALLERY,
                     (ContextKeyExpr.has('galleryExtensionHasPreReleaseVersion')),
                     (ContextKeyExpr.has('installedExtensionIsOptedToPreRelease')),
                    ContextKeyExpr.not('inExtensionEditor'),
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                    ContextKeyExpr.not('isBuiltinExtension')
                )))
            },
            run: async (accessor, id) => {
                const instantiationService = accessor.get(IInstantiationService);
                const extensionWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const extension = extensionWorkbenchService.local.find(e => areSameExtensions(e.identifier, { id }));
                if (extension) {
                    const action = instantiationService.createInstance(TogglePreReleaseExtensionAction);
                    action.extension = extension;
                    return action.run();
                }
            }
        });
        this.registerExtensionAction({
            id: ClearLanguageAction.ID,
            title: ClearLanguageAction.TITLE,
            menu: {
                id: MenuId.ExtensionContext,
                group: INSTALL_ACTIONS_GROUP,
                order: 0,
                when: ( (ContextKeyExpr.and(
                    ContextKeyExpr.not('inExtensionEditor'),
                     (ContextKeyExpr.has('canSetLanguage')),
                     (ContextKeyExpr.has('isActiveLanguagePackExtension'))
                )))
            },
            run: async (accessor, extensionId) => {
                const instantiationService = accessor.get(IInstantiationService);
                const extensionsWorkbenchService = accessor.get(IExtensionsWorkbenchService);
                const extension = (await extensionsWorkbenchService.getExtensions([{ id: extensionId }], CancellationToken.None))[0];
                const action = instantiationService.createInstance(ClearLanguageAction);
                action.extension = extension;
                return action.run();
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.copyExtension',
            title: ( localize2WithPath(_moduleId, 116, 'Copy')),
            menu: {
                id: MenuId.ExtensionContext,
                group: '1_copy'
            },
            run: async (accessor, extensionId) => {
                const clipboardService = accessor.get(IClipboardService);
                const extension = this.extensionsWorkbenchService.local.filter(e => areSameExtensions(e.identifier, { id: extensionId }))[0]
                    || (await this.extensionsWorkbenchService.getExtensions([{ id: extensionId }], CancellationToken.None))[0];
                if (extension) {
                    const name = ( localizeWithPath(_moduleId, 117, 'Name: {0}', extension.displayName));
                    const id = ( localizeWithPath(_moduleId, 118, 'Id: {0}', extensionId));
                    const description = ( localizeWithPath(_moduleId, 119, 'Description: {0}', extension.description));
                    const verision = ( localizeWithPath(_moduleId, 120, 'Version: {0}', extension.version));
                    const publisher = ( localizeWithPath(_moduleId, 121, 'Publisher: {0}', extension.publisherDisplayName));
                    const link = extension.url ? ( localizeWithPath(_moduleId, 122, 'VS Marketplace Link: {0}', `${extension.url}`)) : null;
                    const clipboardStr = `${name}\n${id}\n${description}\n${verision}\n${publisher}${link ? '\n' + link : ''}`;
                    await clipboardService.writeText(clipboardStr);
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.copyExtensionId',
            title: ( localize2WithPath(_moduleId, 123, 'Copy Extension ID')),
            menu: {
                id: MenuId.ExtensionContext,
                group: '1_copy'
            },
            run: async (accessor, id) => accessor.get(IClipboardService).writeText(id)
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.configure',
            title: ( localize2WithPath(_moduleId, 124, 'Extension Settings')),
            menu: {
                id: MenuId.ExtensionContext,
                group: '2_configure',
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                     (ContextKeyExpr.has('extensionHasConfiguration'))
                ))),
                order: 1
            },
            run: async (accessor, id) => accessor.get(IPreferencesService).openSettings({ jsonEditor: false, query: `@ext:${id}` })
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.configureKeybindings',
            title: ( localize2WithPath(_moduleId, 125, 'Extension Keyboard Shortcuts')),
            menu: {
                id: MenuId.ExtensionContext,
                group: '2_configure',
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                     (ContextKeyExpr.has('extensionHasKeybindings'))
                ))),
                order: 2
            },
            run: async (accessor, id) => accessor.get(IPreferencesService).openGlobalKeybindingSettings(false, { query: `@ext:${id}` })
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.toggleApplyToAllProfiles',
            title: ( localize2WithPath(_moduleId, 126, "Apply Extension to all Profiles")),
            toggled: ( (ContextKeyExpr.has('isApplicationScopedExtension'))),
            menu: {
                id: MenuId.ExtensionContext,
                group: '2_configure',
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('extensionStatus', 'installed')),
                     (( (ContextKeyExpr.has('isDefaultApplicationScopedExtension'))).negate()),
                     (( (ContextKeyExpr.has('isBuiltinExtension'))).negate()),
                     (ContextKeyExpr.equals('isWorkspaceScopedExtension', false))
                ))),
                order: 3
            },
            run: async (accessor, id) => {
                const extension = this.extensionsWorkbenchService.local.find(e => areSameExtensions({ id }, e.identifier));
                if (extension) {
                    return this.extensionsWorkbenchService.toggleApplyExtensionToAllProfiles(extension);
                }
            }
        });
        this.registerExtensionAction({
            id: TOGGLE_IGNORE_EXTENSION_ACTION_ID,
            title: ( localize2WithPath(_moduleId, 127, "Sync This Extension")),
            menu: {
                id: MenuId.ExtensionContext,
                group: '2_configure',
                when: ( (ContextKeyExpr.and(
                    CONTEXT_SYNC_ENABLEMENT,
                     (ContextKeyExpr.equals('isWorkspaceScopedExtension', false))
                ))),
                order: 4
            },
            run: async (accessor, id) => {
                const extension = this.extensionsWorkbenchService.local.find(e => areSameExtensions({ id }, e.identifier));
                if (extension) {
                    return this.extensionsWorkbenchService.toggleExtensionIgnoredToSync(extension);
                }
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.ignoreRecommendation',
            title: ( localize2WithPath(_moduleId, 128, "Ignore Recommendation")),
            menu: {
                id: MenuId.ExtensionContext,
                group: '3_recommendations',
                when: ( (ContextKeyExpr.has('isExtensionRecommended'))),
                order: 1
            },
            run: async (accessor, id) => accessor.get(IExtensionIgnoredRecommendationsService).toggleGlobalIgnoredRecommendation(id, true)
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.undoIgnoredRecommendation',
            title: ( localize2WithPath(_moduleId, 129, "Undo Ignored Recommendation")),
            menu: {
                id: MenuId.ExtensionContext,
                group: '3_recommendations',
                when: ( (ContextKeyExpr.has('isUserIgnoredRecommendation'))),
                order: 1
            },
            run: async (accessor, id) => accessor.get(IExtensionIgnoredRecommendationsService).toggleGlobalIgnoredRecommendation(id, false)
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.addExtensionToWorkspaceRecommendations',
            title: ( localize2WithPath(_moduleId, 130, "Add to Workspace Recommendations")),
            menu: {
                id: MenuId.ExtensionContext,
                group: '3_recommendations',
                when: ( (ContextKeyExpr.and(
                     (WorkbenchStateContext.notEqualsTo('empty')),
                     (( (ContextKeyExpr.has('isBuiltinExtension'))).negate()),
                     (( (ContextKeyExpr.has('isExtensionWorkspaceRecommended'))).negate()),
                     (( (ContextKeyExpr.has('isUserIgnoredRecommendation'))).negate()),
                     (ContextKeyExpr.notEquals('extensionSource', 'resource'))
                ))),
                order: 2
            },
            run: (accessor, id) => accessor.get(IWorkspaceExtensionsConfigService).toggleRecommendation(id)
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.removeExtensionFromWorkspaceRecommendations',
            title: ( localize2WithPath(_moduleId, 131, "Remove from Workspace Recommendations")),
            menu: {
                id: MenuId.ExtensionContext,
                group: '3_recommendations',
                when: ( (ContextKeyExpr.and(
                     (WorkbenchStateContext.notEqualsTo('empty')),
                     (( (ContextKeyExpr.has('isBuiltinExtension'))).negate()),
                     (ContextKeyExpr.has('isExtensionWorkspaceRecommended'))
                ))),
                order: 2
            },
            run: (accessor, id) => accessor.get(IWorkspaceExtensionsConfigService).toggleRecommendation(id)
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.addToWorkspaceRecommendations',
            title: ( localize2WithPath(_moduleId, 132, "Add Extension to Workspace Recommendations")),
            category: ( localizeWithPath(_moduleId, 3, "Extensions")),
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(
                     (WorkbenchStateContext.isEqualTo('workspace')),
                     (ContextKeyExpr.equals('resourceScheme', Schemas.extension))
                ))),
            },
            async run(accessor) {
                const editorService = accessor.get(IEditorService);
                const workspaceExtensionsConfigService = accessor.get(IWorkspaceExtensionsConfigService);
                if (!(editorService.activeEditor instanceof ExtensionsInput)) {
                    return;
                }
                const extensionId = editorService.activeEditor.extension.identifier.id.toLowerCase();
                const recommendations = await workspaceExtensionsConfigService.getRecommendations();
                if (recommendations.includes(extensionId)) {
                    return;
                }
                await workspaceExtensionsConfigService.toggleRecommendation(extensionId);
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.addToWorkspaceFolderRecommendations',
            title: ( localize2WithPath(_moduleId, 133, "Add Extension to Workspace Folder Recommendations")),
            category: ( localizeWithPath(_moduleId, 3, "Extensions")),
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(
                     (WorkbenchStateContext.isEqualTo('folder')),
                     (ContextKeyExpr.equals('resourceScheme', Schemas.extension))
                ))),
            },
            run: () => this.commandService.executeCommand('workbench.extensions.action.addToWorkspaceRecommendations')
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.addToWorkspaceIgnoredRecommendations',
            title: ( localize2WithPath(_moduleId, 134, "Add Extension to Workspace Ignored Recommendations")),
            category: ( localizeWithPath(_moduleId, 3, "Extensions")),
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(
                     (WorkbenchStateContext.isEqualTo('workspace')),
                     (ContextKeyExpr.equals('resourceScheme', Schemas.extension))
                ))),
            },
            async run(accessor) {
                const editorService = accessor.get(IEditorService);
                const workspaceExtensionsConfigService = accessor.get(IWorkspaceExtensionsConfigService);
                if (!(editorService.activeEditor instanceof ExtensionsInput)) {
                    return;
                }
                const extensionId = editorService.activeEditor.extension.identifier.id.toLowerCase();
                const unwantedRecommendations = await workspaceExtensionsConfigService.getUnwantedRecommendations();
                if (unwantedRecommendations.includes(extensionId)) {
                    return;
                }
                await workspaceExtensionsConfigService.toggleUnwantedRecommendation(extensionId);
            }
        });
        this.registerExtensionAction({
            id: 'workbench.extensions.action.addToWorkspaceFolderIgnoredRecommendations',
            title: ( localize2WithPath(
                _moduleId,
                135,
                "Add Extension to Workspace Folder Ignored Recommendations"
            )),
            category: ( localizeWithPath(_moduleId, 3, "Extensions")),
            menu: {
                id: MenuId.CommandPalette,
                when: ( (ContextKeyExpr.and(
                     (WorkbenchStateContext.isEqualTo('folder')),
                     (ContextKeyExpr.equals('resourceScheme', Schemas.extension))
                ))),
            },
            run: () => this.commandService.executeCommand('workbench.extensions.action.addToWorkspaceIgnoredRecommendations')
        });
        this.registerExtensionAction({
            id: ConfigureWorkspaceRecommendedExtensionsAction.ID,
            title: { value: ConfigureWorkspaceRecommendedExtensionsAction.LABEL, original: 'Configure Recommended Extensions (Workspace)' },
            category: ( localizeWithPath(_moduleId, 3, "Extensions")),
            menu: {
                id: MenuId.CommandPalette,
                when: ( (WorkbenchStateContext.isEqualTo('workspace'))),
            },
            run: () => runAction(this.instantiationService.createInstance(ConfigureWorkspaceRecommendedExtensionsAction, ConfigureWorkspaceRecommendedExtensionsAction.ID, ConfigureWorkspaceRecommendedExtensionsAction.LABEL))
        });
    }
    registerExtensionAction(extensionActionOptions) {
        const menus = extensionActionOptions.menu ? Array.isArray(extensionActionOptions.menu) ? extensionActionOptions.menu : [extensionActionOptions.menu] : [];
        let menusWithOutTitles = [];
        const menusWithTitles = [];
        if (extensionActionOptions.menuTitles) {
            for (let index = 0; index < menus.length; index++) {
                const menu = menus[index];
                const menuTitle = extensionActionOptions.menuTitles[menu.id.id];
                if (menuTitle) {
                    menusWithTitles.push({ id: menu.id, item: { ...menu, command: { id: extensionActionOptions.id, title: menuTitle } } });
                }
                else {
                    menusWithOutTitles.push(menu);
                }
            }
        }
        else {
            menusWithOutTitles = menus;
        }
        const disposables = ( (new DisposableStore()));
        disposables.add(registerAction2(class extends Action2 {
            constructor() {
                super({
                    ...extensionActionOptions,
                    menu: menusWithOutTitles
                });
            }
            run(accessor, ...args) {
                return extensionActionOptions.run(accessor, ...args);
            }
        }));
        if (menusWithTitles.length) {
            disposables.add(MenuRegistry.appendMenuItems(menusWithTitles));
        }
        return disposables;
    }
};
ExtensionsContributions = ( (__decorate([
    ( (__param(0, IExtensionManagementServerService))),
    ( (__param(1, IExtensionGalleryService))),
    ( (__param(2, IContextKeyService))),
    ( (__param(3, IPaneCompositePartService))),
    ( (__param(4, IExtensionsWorkbenchService))),
    ( (__param(5, IWorkbenchExtensionEnablementService))),
    ( (__param(6, IInstantiationService))),
    ( (__param(7, IDialogService))),
    ( (__param(8, ICommandService)))
], ExtensionsContributions)));
let ExtensionStorageCleaner = class ExtensionStorageCleaner {
    constructor(extensionManagementService, storageService) {
        ExtensionStorageService.removeOutdatedExtensionVersions(extensionManagementService, storageService);
    }
};
ExtensionStorageCleaner = ( (__decorate([
    ( (__param(0, IExtensionManagementService))),
    ( (__param(1, IStorageService)))
], ExtensionStorageCleaner)));
const workbenchRegistry = ( (Registry.as(Extensions$4.Workbench)));
workbenchRegistry.registerWorkbenchContribution(ExtensionsContributions, 3 );
workbenchRegistry.registerWorkbenchContribution(StatusUpdater, 4 );
workbenchRegistry.registerWorkbenchContribution(MaliciousExtensionChecker, 4 );
workbenchRegistry.registerWorkbenchContribution(KeymapExtensions, 3 );
workbenchRegistry.registerWorkbenchContribution(ExtensionsViewletViewsContribution, 3 );
workbenchRegistry.registerWorkbenchContribution(ExtensionActivationProgress, 4 );
workbenchRegistry.registerWorkbenchContribution(ExtensionDependencyChecker, 4 );
workbenchRegistry.registerWorkbenchContribution(ExtensionEnablementWorkspaceTrustTransitionParticipant, 3 );
workbenchRegistry.registerWorkbenchContribution(ExtensionsCompletionItemsProvider, 3 );
workbenchRegistry.registerWorkbenchContribution(UnsupportedExtensionsMigrationContrib, 4 );
workbenchRegistry.registerWorkbenchContribution(DeprecatedExtensionsChecker, 4 );
if (isWeb) {
    workbenchRegistry.registerWorkbenchContribution(ExtensionStorageCleaner, 4 );
}
registerAction2(ShowRuntimeExtensionsAction);

export { CONTEXT_HAS_LOCAL_SERVER, CONTEXT_HAS_REMOTE_SERVER, CONTEXT_HAS_WEB_SERVER };
